import React, { useRef, useState, useEffect } from "react";
import "../common/globals";
import Story from "../components/Story";
import Slider from "react-slick";
import { getInitialPropsForStories } from "../common/page-props";
import css from "./stories.module.scss";
import Error from "./_error";
import { Global, css as emotionCss } from "@emotion/core";
import slickCss from "../common/slick-css";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + " " + css["next-btn"]}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + " " + css["prev-btn"]}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
    />
  );
}
function Stories(props) {
  const glances = props.glances;
  const slider = useRef(null);
  const settings = {
    dots: true,
    infinite: false,
    dotsClass: css["slick-custom-dots"] + " slick-dots ",
    arrows: true,
    autoplay: true,
    speed: 1000,
    lazyLoad: true,
    autoplaySpeed: 8000,
    focusOnSelect: true,
    pauseOnHover: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };
  const [styles, setStyles] = useState({
    height: "100vh"
  });
  useEffect(() => {
    process.browser
      ? setStyles({ height: window.innerHeight })
      : setStyles({ height: "100vh" });
  }, []);
  return glances.length ? (
    <>
      <Global styles={emotionCss`${slickCss}`} />
      <div className={css["stories-section"]} style={styles}>
        <Slider ref={slider} {...settings}>
          {glances.map((item, index) => {
            return (
              <Story
                key={item.id}
                glance={item}
                index={index}
                styles={styles}
                query={props.query}
              />
            );
          })}
        </Slider>
      </div>
    </>
  ) : (
    <Error statusCode={404} />
  );
}

Stories.getInitialProps = getInitialPropsForStories;
export default Stories;
